import axios, { AxiosResponse } from 'axios';
import Endpoints from '../endpoints';
import { NoContentResponse } from '../responses';

export const resetPassword = (email: string): Promise<AxiosResponse<NoContentResponse>> =>
  axios.post(Endpoints.authentication.RESET_PASSWORD(), { email });

export default async (email: string) => await resetPassword(email);
